import React from 'react';
import { Helmet } from 'react-helmet';
import useTranslation from '../hooks/useTranslation';

/* globals CSS_CONFIG */

export interface SiteMetadataProps {
  pageTitle?: string;
}

const SiteMetadata: React.FC<SiteMetadataProps> = ({
  pageTitle,
}): JSX.Element => {
  const { t } = useTranslation();
  const siteName = t('components.appHeader.title');
  const { LANGUAGE, COUNTRY, HTMLLANG, HTMLDIR } = CSS_CONFIG;
  const language = HTMLLANG || LANGUAGE;
  const locale =
    language && COUNTRY ? `${language}-${COUNTRY.toUpperCase()}` : 'en-GB';

  return (
    <Helmet defaultTitle={siteName} titleTemplate={`%s | ${siteName}`}>
      <title>{pageTitle}</title>
      <meta name="robots" content="noindex" />
      <html lang={locale} dir={HTMLDIR} />
    </Helmet>
  );
};

export default SiteMetadata;
